<template>
    <router-view></router-view>
</template>
<script>

    export default {
        name: "visual-intercom",
        data(){
            return{

            }
        },
    }
</script>

<style lang="less" scoped>
    .visual-intercom{

    }

</style>